import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  RepairsViewPage,
  RepairsViewHeader,
  RepairFormCards,
  RepairsViewTopCards,
  RepairsViewImages,
} from './RepairsViewComponents';
import { Repairs } from './Repairs';
import { RepairSetUpdateMultipleModal } from '../../design-system';
import { i18n } from '../../i18n';
import { RoleGuard } from '../../routes';

export const RepairsView = () => {
  const params: any = useParams();
  const [repair, setRepair] = useState<any>();

  const handleRowClick = (data: any) => {
    const el = document.querySelector('#dashboard-main');
    el?.scrollTo({ top: 0, behavior: 'smooth' });

    setRepair(data);
  };

  return (
    <RoleGuard roles={['TRADER']} isMobile negative>
      <RepairsViewPage id={'repair-view-page'}>
        {!!repair && (
          <>
            <RepairsViewHeader repair={repair} containerId={params.id} />
            <RepairFormCards>
              <RepairsViewTopCards repair={repair} />
              <RepairsViewImages
                title={i18n.t('label.beforeImages')}
                images={repair.beforeImages}
                repairId={repair.id}
                repairStatus={repair.status}
                imageCategory={'before'}
                onImagesUpdated={(beforeImages) =>
                  setRepair((prev: any) => ({ ...prev, beforeImages }))
                }
              />
              <RepairsViewImages
                title={i18n.t('label.afterImages')}
                images={repair.afterImages}
                repairId={repair.id}
                repairStatus={repair.status}
                imageCategory={'after'}
                onImagesUpdated={(afterImages) =>
                  setRepair((prev: any) => ({ ...prev, afterImages }))
                }
              />
            </RepairFormCards>
          </>
        )}
        <Repairs containerId={params.id} handleRowClick={handleRowClick} />
      </RepairsViewPage>
      <RepairSetUpdateMultipleModal />
    </RoleGuard>
  );
};
